/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import photo1 from "assets/images/saintvalentin-1.jpg";
import photo2 from "assets/images/saintvalentin-2.jpg";
import photo3 from "assets/images/saintvalentin-3.jpg";
import photo4 from "assets/images/saintvalentin-4.jpg";
import photo5 from "assets/images/saintvalentin-6.jpg";
import photo6 from "assets/images/saintvalentin-7.jpg";

export default [
  {
    title: "Saint Valentin",
    description: "L'Art de la Célébration au Cœur de la Saint-Valentin 2025",
    items: [
      {
        image: photo1,
      },
      {
        image: photo2,
      },
      {
        image: photo3,
      },
      {
        image: photo4,
      },
      {
        image: photo5,
      },
      {
        image: photo6,
      },
    ],
  },
];
